import { createMicrofrontendUI } from '../createMicrofrontendUI';
import { APIRuntimeBuilder, exportsModule } from '@cian/mf-registry/browser';
import { getMicrofrontendMethods } from '../../getMicrofrontendMethods';
import { IExtendedContext } from '../../../types/extendedContext';

export const initMicrofrontend = (context: IExtendedContext) => {
  exportsModule({
    ui: {
      '/public/v2/get-microfrontend/': createMicrofrontendUI(context),
    },
    api: () => getMicrofrontendMethods(context) as APIRuntimeBuilder,
  });
};
